import moment from "moment";
import { createSelector } from "reselect";

import type { PollService } from "@busbud/core-types";
import { OutageAnnotationCategory } from "@busbud/int-schemas/udm";

import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getTripsSegments } from "./get-trips-segments";
import { getTrips, getTripsAnnotations } from "../state-accessors";

export const getTripsIdsInOutage = createSelector(
  [getTrips, getTripsSegments, getTripsAnnotations],
  (trips, trips_segments, annotations) => {
    const trips_id = Object.keys(trips);
    return trips_id.filter(id => {
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const trip_annotations = trips[id].annotation_ids.map(
        id => annotations[id]
      );
      return trip_annotations.some(
        annotation =>
          // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
          hasTechnicalOutage(annotation, trips_segments) ||
          // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
          hasServiceDisruption(annotation, trips_segments)
      );
    });
  }
);

export const hasSourceOutages = createSelector(
  [(_state: ResultsReduxState, id: string) => id, getTripsIdsInOutage],
  (trip_id: string, trips_ids_in_outages) => {
    return trips_ids_in_outages.includes(trip_id);
  }
);

const hasTechnicalOutage = (
  annotation: PollService.API.PublicAnnotation,
  trips_segments:
    | Record<string, PollService.API.RelatedPublicSegment>
    | Record<string, PollService.API.RelatedPublicSegmentV4>
) => {
  if (annotation.category !== OutageAnnotationCategory.TechnicalOutage) {
    return false;
  }
  if (annotation.availability === "none") {
    return true;
  }
  // Partial: Everything works except ticket delivery
  return annotation.segment_ids.some(segment_id => {
    const segment = trips_segments[segment_id];
    if (!annotation.ends_at?.timestamp) {
      return true;
    }
    const time_between_outage_and_departure = moment(
      annotation.ends_at.timestamp
      // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    ).diff(moment(segment.departure_time.timestamp));

    return time_between_outage_and_departure > 0;
  });
};

const hasServiceDisruption = (
  annotation: PollService.API.PublicAnnotation,
  trips_segments:
    | Record<string, PollService.API.RelatedPublicSegment>
    | Record<string, PollService.API.RelatedPublicSegmentV4>
) => {
  if (annotation.category !== OutageAnnotationCategory.ServiceDisruption) {
    return false;
  }
  return annotation.segment_ids.some(segment_id => {
    const segment = trips_segments[segment_id];
    if (!annotation.ends_at?.timestamp) {
      return true;
    }
    const time_between_outage_and_departure = moment(
      annotation.ends_at.timestamp
      // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    ).diff(moment(segment.departure_time.timestamp));

    return time_between_outage_and_departure > 0;
  });
};
